export default __webpack_public_path__ + "static/media/BG-image.76a8fe34.png";